
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // This directive can delete site, folder and printer
    //

  function pxDeleteHomeOfficeGroup(
    $http, toastr, $filter, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        tenant: '=resource',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/homeOffice/deleteHomeOfficeGroup/deleteHomeOfficeGroup.template.html',
      link: function(scope) {
        console.log('** scope.context : ', scope.context);
        scope.confirm = {
          delete: false
        };

        scope.delete = function () {
          var homeOfficeGroupsUrl = scope.tenant.info._links['px:homeOfficeGroups'].href;
          var groupsObject = {
            groups: []
          }
          groupsObject.groups.push(scope.context.group.info._links.self.href);
          $http.delete(
            homeOfficeGroupsUrl, 
            {headers: {"Content-Type": "application/json"},
            data: groupsObject}).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"));
            $rootScope.$broadcast('UPDATE_HOME_OFFICE_GROUPS')
          }).catch(function(error) {
            toastr.error($filter("translate")("ERROR"));
          });
          scope.callback();
        }

      }
    };
  }

  pxDeleteHomeOfficeGroup.$inject = ['$http', 'toastr', '$filter', '$rootScope'];

  angular
    .module('printix-admin')
    .directive('pxDeleteHomeOfficeGroup', pxDeleteHomeOfficeGroup);

})();
